import { useEffect, useRef } from 'react';
import { Box, useMediaQuery } from '@mui/material';

import { EventManager } from '@/components/EventManager';
import { Navigation } from '@/components/NewNavigation/Navigation';

export const MainLayout = ({ children }: DummyComponent) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const isSmall = useMediaQuery('(max-width:800px)');

  useEffect(() => {
    // scroll to top on route change
    if (containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (isSmall) {
    return (
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: '50px 1fr',
          height: '100vh',
        }}
      >
        <EventManager />
        <Navigation />
        <main
          ref={containerRef}
          style={{ position: 'relative', overflowY: 'auto' }}
        >
          {children}
        </main>
      </Box>
    );
  }

  return (
    <>
      <EventManager />
      <Navigation />
      <Box
        sx={(theme) => ({
          flex: 1,
          marginTop: '50px',
          marginLeft: '60px',
          [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginTop: 0,
            paddingBottom: '7rem',
          },
        })}
        id="shell-main-content"
      >
        <main ref={containerRef} style={{ position: 'relative' }}>
          {children}
        </main>
      </Box>
    </>
  );
};
